export const ARRIVAL_PROXIMITY_RADIUS_METRES = 500

const toRadians = (degrees) => (degrees * Math.PI) / 180

export const isValidLngLat = (coords) =>
  Array.isArray(coords) &&
  coords.length === 2 &&
  coords.every((value) => Number.isFinite(Number(value)))

export const formatDistance = (metres) => {
  if (!Number.isFinite(metres)) return 'unknown distance'
  if (metres < 1000) return `${Math.round(metres)}m`
  return `${(metres / 1000).toFixed(1)}km`
}

export const getLocationCoordinates = (location) =>
  location?.coordinates || location?.location?.coordinates || null

export const getDistanceMetres = (fromCoords, toCoords) => {
  if (!isValidLngLat(fromCoords) || !isValidLngLat(toCoords)) return null

  const [fromLng, fromLat] = fromCoords.map(Number)
  const [toLng, toLat] = toCoords.map(Number)
  const earthRadiusMetres = 6371000
  const latDelta = toRadians(toLat - fromLat)
  const lngDelta = toRadians(toLng - fromLng)
  const a =
    Math.sin(latDelta / 2) * Math.sin(latDelta / 2) +
    Math.cos(toRadians(fromLat)) *
      Math.cos(toRadians(toLat)) *
      Math.sin(lngDelta / 2) *
      Math.sin(lngDelta / 2)

  return earthRadiusMetres * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
}

export const getArrivalProximityCheck = ({
  status,
  journey,
  currentCoords,
  targetType,
  radiusMetres = ARRIVAL_PROXIMITY_RADIUS_METRES,
}) => {
  const target =
    targetType === 'pickup' || status === 'On Scene'
      ? {
          label: 'pickup',
          coords: getLocationCoordinates(journey?.pickup),
        }
      : targetType === 'dropoff' || status === 'Arrived'
        ? {
            label: 'dropoff',
            coords: getLocationCoordinates(journey?.dropoff),
          }
        : null

  if (!target) return null
  if (!isValidLngLat(target.coords)) return null

  if (!isValidLngLat(currentCoords)) {
    return {
      targetLabel: target.label,
      distanceMetres: null,
      radiusMetres,
      distanceLabel: null,
      unableToVerify: true,
    }
  }

  const distanceMetres = getDistanceMetres(currentCoords, target.coords)
  if (distanceMetres === null || distanceMetres <= radiusMetres) {
    return null
  }

  return {
    targetLabel: target.label,
    distanceMetres,
    radiusMetres,
    distanceLabel: formatDistance(distanceMetres),
  }
}
